<template>
    <v-card class="contact-form" tile flat color="transparent">
        <v-card-title v-if="!embedded">
            <v-toolbar-title><h2 class="text-green">Écrivez-nous!</h2></v-toolbar-title>

            <v-spacer/>

            <v-btn
                icon
                @click="close"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-form 
            ref="contactForm"
            v-model="valid"
            @submit.prevent="submit" 
            @reset="reset" 
        >
            <v-card-text v-if="!sending && !message.show">
                <v-text-field
                    id="contactName"
                    type="text"
                    v-model="form.name"
                    :rules="nameRules"
                    required
                    placeholder="Entrez votre nom complet ici" 
                    :solo="!!$mq.phone"
                />

                <v-text-field
                    id="contactEmail"
                    type="email"
                    v-model="form.email"
                    :rules="emailRules"
                    required
                    placeholder="Entrez votre courriel ici" 
                    :solo="!!$mq.phone"
                />

                <v-textarea
                    id="contactMessage"
                    v-model="form.message"
                    required
                    placeholder="Entrez votre message ici"
                    :rules="messageRules"
                    rows="3"
                    max-rows="6" 
                    :solo="!!$mq.phone"
                />
            </v-card-text>

            <v-progress-circular v-if="sending" indeterminate color="primary" />

            <v-card-actions v-if="!sending && !message.show" class="justify-end">
                <v-btn v-if="!!valid" type="submit" class="submit-btn ml-5 px-5" color="#30B700" dark>Envoyer</v-btn>
            </v-card-actions>
        </v-form>

        <v-card-text v-if="message.show">
            <h3 v-html="message.content"></h3>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "Contact",
    computed: {},
    props: [
        'embedded'
    ],
    data() {
        return {
            form: {
                name: null,
                email: null,
                message: null,
            },
            valid: true,
            sending: false,
            success: false,
            message: {
                show: false,
                style: null,
                content: null,
            },
            nameRules: [
                v => !!v || 'Vous devez entrer votre nom.',
                v => /[A-z-']+\s[A-z-'\s]+/.test(v) || 'Nom complet invalide... veuillez corriger.',
            ],
            emailRules: [
                v => !!v || 'Votre devez entrer un courriel valide.',
                v => /.{2,}@.{2,}\..{2,5}/.test(v) || 'Courriel invalide... veuillez corriger.',
            ],
            messageRules: [
                v => !!v || `Vous devez composer un message.`,
                v => (v && v.length >= 20) || 'Merci de composer un message de plus de 20 caractères.',
            ],
        }
    },
    methods: {
        submit( evt ) {
            evt.preventDefault()
            this.sendEmail()    
        },    
        async sendEmail() {
            this.form.name = this.$p9.parse.name( this.form.name )

            let data = {
                collection: 'messages',
                document: {
                    time: new Date().toISOString(),
                    from: `${ process.env.VUE_APP_ORG } <${ process.env.VUE_APP_EMAIL }>`,
                    to: process.env.VUE_APP_EMAIL,
                    replyTo: `${ this.form.name } <${ this.form.email }>`,
                    subject: `Message provenant d'un utilisateur du site web`,
                    htmlMsg: `<h1>Bonjour,</h1>
                    <p>${ this.form.name } vous a adressé le message suivant via le formulaire de contact de votre site web:</p>
                    <hr>
                    <p><i>${ this.form.message.trim() }</i></p>
                    <hr>
                    <p>Merci de répondre dès que possible.</p>
                    <p>Cordialement,</p>
                    <br>
                    <p>${ process.env.VUE_APP_ORG }</p>`,
                }
            }
            
            this.sending = true
            this.$store.dispatch('addDoc', data)
            .then(res => {
                this.sending = false
                if( !!res.id ) {
                    this.message = {
                        show: true,
                        style: '',
                        content: `Votre message a bien été envoyé et nous y répondrons dès que possible.<br>Merci!`
                    }
                }
            })
            .catch( err => {
                this.sending = false
                    this.message = {
                        show: true,
                        style: '',
                        content: err
                    }
            })
        },
        close() {
            this.reset()
            this.$emit('close')
        },
        reset() {
        this.form = {
            email: '',
            message: ''
        }
        this.sending = false
        this.success = false
        this.message = {
            show: false,
            style: '',
            content: ''
        }
        }
    },
}
</script>

<style>
.submit-btn {
    transition: all 0.5s;
}
</style>
